const CAPTCHA_V2 = "6Lf8P_AUAAAAANDzCNQbC2335S1hc6BxykzUcGrz"

export default {
    CAPTCHA_V2,
}